export default __webpack_public_path__ + "static/media/DSC06023.ea83413a.jpg";